//
//
//
//
//
//
//

export default {
    name: 'guideBindCardDialog',
    props: [
        'value',
        'themeType',
    ],
    data() {
        return {
            show: this.value
        }
    },
    watch: {
        show() {
            this.$emit('input', this.show)
        },
        value() {
            this.show = this.value
        }
    }
}
